export default {
  nav: {
    home: 'خانه',
    categories: 'دسته‌بندی‌ها',
    cart: 'سبد خرید',
    orders: 'سفارش‌ها',
    wishlist: 'علاقه‌مندی‌ها',
    vendor: 'فروشنده',
    notifications: 'اعلانات',
    profile: 'پروفایل',
    addresses: 'آدرس‌ها',
    paymentMethods: 'روش پرداخت',
    security: 'امنیت',
    settings: 'تنظیمات',
    storyEditor: 'استوری ادیتور',
    more: 'بیشتر',
    closeMenu: 'بستن منو',
    language: 'زبان',
    help: 'راهنما و پشتیبانی',
  },
  header: {
    welcome: 'خوش آمدید',
    searchPlaceholder: 'جستجو در محصولات، برندها و دسته‌بندی‌ها...',
    searchMobile: 'جستجو...',
    search: 'جستجو',
    delivery: 'پیک',
    pickup: 'حضوری',
    selectAddress: 'انتخاب آدرس',
    selectLocation: 'انتخاب موقعیت',
    schedule: 'زمان‌بندی',
    setAddress: 'تنظیم آدرس',
    inStorePickup: 'تحویل حضوری',
    notifications: 'اعلانات',
    customer: 'مشتری',
    guest: 'مهمان',
    address: 'آدرس',
    scheduledSelected: 'ارسال زمان\u200cبندی شده انتخاب شد',
    courierSelected: 'ارسال با پیک انتخاب شد',
    pickupSelected: 'تحویل حضوری انتخاب شد',
    searchingFor: 'دنبال',
  },
  common: {
    save: 'ذخیره',
    cancel: 'لغو',
    edit: 'ویرایش',
    delete: 'حذف',
    add: 'افزودن',
    confirm: 'تایید',
    back: 'بازگشت',
    backToProfile: 'بازگشت به پروفایل',
    next: 'بعدی',
    close: 'بستن',
    loading: 'در حال بارگذاری...',
    error: 'خطا',
    success: 'موفق',
    empty: 'خالی',
    seeAll: 'مشاهده همه',
    appName: 'بازارک',
    appNameEn: 'Bazaarak',
    currency: 'تومان',
    viewAll: 'مشاهده همه',
    items: 'مورد',
    store: 'فروشگاه',
    clear: 'پاک کردن',
    actions: 'عملیات',
    email: 'ایمیل',
    phone: 'تلفن',
    city: 'شهر',
    yes: 'بله',
    no: 'خیر',
    enabled: 'فعال',
    disabled: 'غیرفعال',
    enable: 'فعال‌سازی',
    noResults: 'نتیجه‌ای یافت نشد',
    manageAddresses: 'مدیریت آدرس‌ها',
    shippingAddress: 'آدرس ارسال',
    addAddress: 'افزودن آدرس',
    changeAddress: 'تغییر آدرس',
    noSavedAddresses: 'آدرس ذخیره‌شده‌ای وجود ندارد',
    search: 'جستجو',
    addAddressToContinue: 'برای ادامه یک آدرس اضافه کنید',
    noSavedMethods: 'روش پرداخت ذخیره‌شده‌ای وجود ندارد',
    addMethodToContinue: 'برای ادامه یک روش پرداخت اضافه کنید',
    selectShippingAddress: 'لطفاً آدرس ارسال را انتخاب کنید',
    checkoutFailed: 'پرداخت ناموفق بود',
  },
  auth: {
    login: 'ورود',
    register: 'ثبت‌نام',
    logout: 'خروج',
    email: 'ایمیل',
    password: 'رمز عبور',
    phone: 'شماره موبایل',
    forgotPassword: 'رمز عبور را فراموش کرده‌ام',
    signInRequired: 'نیاز به ورود',
    addressSignInPrompt: 'برای مدیریت آدرس‌های تحویل وارد شوید',
    unauthorized: 'نشست منقضی شد. لطفاً دوباره وارد شوید.',
    signIn: 'ورود',
    signUp: 'ثبت‌نام',
    createAccount: 'ساختن حساب',
    welcomeBack: 'خوش برگشتید!',
    createYourAccount: 'حساب کاربری بسازید',
    customer: 'مشتری',
    vendor: 'فروشنده',
    name: 'نام',
    fullName: 'نام و نام خانوادگی',
    storeName: 'نام فروشگاه',
    confirmPassword: 'تکرار رمز عبور',
    enterYourName: 'نام خود را وارد کنید',
    emailOrUsername: 'ایمیل / نام کاربری',
    enterEmailOrUsername: 'ایمیل یا نام کاربری خود را وارد کنید',
    enterYourPassword: 'رمز عبور خود را وارد کنید',
    confirmYourPassword: 'رمز عبور را تایید کنید',
    enterStoreName: 'نام فروشگاه خود را وارد کنید',
    enterPhoneNumber: '۰۹۱۲۳۴۵۶۷۸۹',
    rememberMe: 'مرا به خاطر بسپار',
    orContinueWith: 'یا ادامه با',
    continueWithGoogle: 'ادامه با گوگل',
    continueWithApple: 'ادامه با اپل',
    noAccount: 'حساب ندارید؟',
    hasAccount: 'قبلاً ثبت‌نام کرده‌اید؟',
    backToHome: 'بازگشت به خانه',
    signingIn: 'در حال ورود...',
    creatingAccount: 'در حال ساخت حساب...',
    verifiedVendor: 'فروشنده تایید شده',
  },
  product: {
    addToCart: 'افزودن به سبد',
    addToWishlist: 'افزودن به علاقه‌مندی‌ها',
    buyNow: 'خرید فوری',
    outOfStock: 'ناموجود',
    discount: 'تخفیف',
    price: 'قیمت',
    originalPrice: 'قیمت اصلی',
    reviews: 'نظر',
    description: 'توضیحات',
    related: 'محصولات مرتبط',
    inStock: 'موجود',
    quantity: 'تعداد',
    availability: 'موجودی',
    selectVariant: 'انتخاب مدل',
    save: 'صرفه‌جویی',
    notFound: 'محصول پیدا نشد',
    notFoundDesc: 'این محصول وجود ندارد یا حذف شده است.',
    browseProducts: 'مرور محصولات',
    home: 'خانه',
    addingToCart: 'در حال افزودن...',
    addingToWishlist: 'در حال افزودن...',
    addedToCart: 'به سبد اضافه شد!',
    addedToWishlist: 'به علاقه‌مندی‌ها اضافه شد!',
    failedToLoad: 'بارگذاری محصول ناموفق بود',
    failedToAddCart: 'افزودن به سبد ناموفق بود',
    failedToAddWishlist: 'افزودن به علاقه‌مندی‌ها ناموفق بود',
    viewCart: 'مشاهده سبد',
    products: 'محصول',
    nSellers: '{{count}} فروشنده',
    fromPrice: 'از',
    priceRange: 'از €{{from}} تا €{{to}}',
    chooseStore: 'انتخاب فروشگاه',
    soldBySelected: 'توسط فروشگاه انتخاب‌شده',
    availableAtStores: 'در {{count}} فروشگاه موجود است',
    store: 'فروشگاه',
    multipleVariants: '{{count}} گزینه',
  },
  cart: {
    title: 'سبد خرید',
    empty: 'سبد خرید شما خالی است',
    emptyDesc: 'برای افزودن محصول، خرید کنید',
    total: 'جمع کل',
    checkout: 'ادامه به پرداخت',
    continueShopping: 'ادامه خرید',
    orderSummary: 'خلاصه سفارش',
    subtotal: 'جمع محصولات',
    shipping: 'هزینه ارسال',
    tax: 'مالیات (۱۹٪)',
    discount: 'تخفیف',
    couponCode: 'کد تخفیف',
    enterCode: 'کد را وارد کنید',
    apply: 'اعمال',
    couponApplied: 'کد تخفیف اعمال شد (۱۰٪ تخفیف)',
    free: 'رایگان',
    processing: 'در حال پردازش...',
    secureCheckout: 'پرداخت امن',
    signIn: 'لطفاً وارد شوید',
    signInDesc: 'برای مشاهده سبد خرید وارد شوید',
    itemsInCart: 'مورد در سبد',
    each: 'هر کدام',
    impulseTitle: 'قبل از پرداخت…',
    impulseSubtitle: 'پیشنهاد لحظه آخری',
    impulseHot: 'داغ',
    impulseDeal: 'پیشنهاد ویژه',
    impulseCampaignDesc: 'تخفیف محدود — قبل از تسویه ببین!',
    impulseShopDeals: 'ببین تخفیف‌ها',
    impulseProductDesc: '{{percent}}٪ تخفیف — الان اضافه کن',
    impulseProductStoreDesc: '{{percent}}٪ تخفیف · {{store}}',
    impulseViewProduct: 'ببین محصول',
    impulseAddNow: 'بگیرش',
    impulseStoreDesc: 'فروشگاه‌های پیشنهادی موقع تسویه',
    impulseVisitStore: 'برو فروشگاه',
    impulseStoreBadge: 'فروشگاه',
  },
  categories: {
    browse: 'مرور دسته‌بندی‌ها',
    explore: 'مجموعه گسترده ما را در تمام دسته‌بندی‌ها کاوش کنید',
    all: 'همه دسته‌بندی‌ها',
    all: 'همه دسته‌بندی‌ها',
    electronics: 'الکترونیک',
    fashion: 'مد و پوشاک',
    home: 'خانه و باغ',
    sports: 'ورزش و فضای باز',
    books: 'کتاب و رسانه',
    beauty: 'زیبایی و سلامت',
    toys: 'اسباب‌بازی و بازی',
    automotive: 'خودرو',
    jewelry: 'جواهرات و ساعت',
    pet: 'لوازم حیوانات',
    office: 'لوازم اداری',
    productsAvailable: 'محصول موجود',
    subcategories: 'زیردسته‌ها',
    noProductsFound: 'محصولی پیدا نشد برای',
    products: 'محصولات',
  },
  home: {
    browseByCategory: 'خرید بر اساس دسته‌بندی',
    browseCategoryDesc: 'طیف گسترده‌ای از دسته‌بندی‌های ممتاز ما را کاوش کنید',
    featuredProducts: 'محصولات ویژه',
    featuredDesc: 'آیتم‌های منتخب فقط برای شما',
    nearYouProducts: 'نزدیک شما همین الان',
    nearYouDesc: 'بر اساس منطقه و ساعت محلی شما',
    topProducts: 'محصولات برتر',
    topProductsDesc: 'پرفروش‌ترین‌ها در این هفته',
    sold: 'فروش رفته',
    youMightLike: 'شاید دوست داشته باشید',
    youMightLikeDesc: 'محصولات منتخب از فروشگاه‌های مورد علاقه شما',
    trendingNow: 'پرطرفدارترین‌ها',
    trendingDesc: 'با آخرین ترندها جلوتر باشید',
    premiumMarketplace: 'مارکت‌پلیس ممتاز',
    heroTitle1: 'کشف کنید',
    heroTitle2: 'محصولات ممتاز',
    heroDesc: 'تجربه خرید لوکس با مجموعه منتخب ما از برندهای ممتاز و محصولات انحصاری. سفر شما به سمت برتری از اینجا شروع می‌شود.',
    exploreNow: 'کاوش کنید',
    becomeVendor: 'فروشنده شوید',
    products: 'محصول',
    vendors: 'فروشنده',
    happyCustomers: 'مشتری راضی',
    deliverTo: 'ارسال به',
    selectAddress: 'انتخاب آدرس',
    schedule: 'زمان‌بندی',
    selectDateTime: 'انتخاب تاریخ و زمان',
    popularSearches: 'جستجوهای محبوب',
    shopNow: 'خرید کنید',
    explore: 'کاوش',
    summerCollection: 'کلکسیون تابستانی ۲۰۲۴',
    summerDesc: 'آخرین ترندهای این فصل را کشف کنید',
    smartHome: 'لوازم هوشمند خانه',
    smartHomeDesc: 'فضای زندگی خود را متحول کنید',
    wellness: 'سلامت و مراقبت',
    wellnessDesc: 'محصولات ممتاز برای رفاه شما',
    fashion: 'مد',
    tech: 'تکنولوژی',
    beauty: 'زیبایی',
    selectDeliveryAddress: 'انتخاب آدرس تحویل',
    scheduleDelivery: 'زمان‌بندی تحویل',
    addNewAddress: 'افزودن آدرس جدید',
    selectDate: 'انتخاب تاریخ',
    selectTimeSlot: 'انتخاب بازه زمانی',
    confirmSchedule: 'تایید زمان‌بندی',
    topVendors: 'بهترین فروشگاه‌ها',
    topVendorsDesc: 'فروشگاه‌های مورد اعتماد نزد شما',
    topRatedNearYou: 'بالاترین امتیاز در نزدیکی شما',
    discoverWhatYouLike: 'کشف کنید چه چیزی دوست دارید',
    sponsored: 'حمایت‌شده',
    filter: {
      'all': 'همه',
      'wishlist': 'علاقه‌مندی‌ها',
      'on-sale': 'تخفیف‌دار',
      'free-shipping': 'ارسال رایگان',
      'new-arrivals': 'جدیدترین‌ها',
      'best-seller': 'پرفروش‌ترین',
      'top-rated': 'بالاترین امتیاز',
      'price-drop': 'کاهش قیمت',
      'express': 'ارسال سریع',
      'premium': 'ممتاز',
    },
    topStores: 'فروشگاه‌های برتر',
    nearBadge: 'نزدیک',
    since: 'از سال',
    delivery: 'پیک',
    noDelivery: 'بدون پیک',
    freeShipping: 'ارسال رایگان',
    specialBadge: 'ویژه',
    storePromoFallback: 'تخفیف ویژه تا ۳۰٪',
    flashSale: 'تخفیف نارنجی!',
    flashSaleDesc: 'فرصت محدود — قیمت‌های ویژه کمپین',
    flashSaleBadge: 'ویژه',
    campaignStockLeft: '{{count}} عدد مانده!',
    campaignPack: 'پک {{count}} تایی',
    seasonalCampaign: 'کمپین فصلی',
  },
  supermarket: {
    searchPlaceholder: 'جستجو در سوپرمارکت بازارک',
    promoTitle: 'جایزه نقدی بزرگ ببر!',
    promoCta: 'ورود به قرعه‌کشی',
    modeSuper: 'سوپرمارکت',
    modeSuperHint: 'ارسال فوری',
    modeHyper: 'هایپرمارکت',
    modeHyperHint: 'ارسال زمان‌بندی‌شده',
    previousPurchases: 'خریدهای قبلی',
    suggestedForYou: 'پیشنهاد برای شما',
    nearbyStores: '{{count}} فروشگاه اطراف شما',
    eta: 'تا ۳۰ دقیقه',
    viewAllStores: 'مشاهده همه فروشگاه‌ها',
    shopCategories: 'خرید بر اساس دسته‌بندی',
    railOffers: 'پیشنهادهای ویژه برای شما',
    railTrending: 'پرطرفدار همین الان',
    railFresh: 'انتخاب‌های تازه',
    homeEntryTitle: 'سوپرمارکت بازارک',
    homeEntryHint: 'ارسال فوری و تخفیف‌های روزانه',
    turbo: 'ارسال توربو',
    bannerFallbackTitle: 'پیشنهادهای ویژه',
    bannerFallbackSub: 'تا ۳۰٪ تخفیف',
    productCountBadge: '{{count}} محصول',
  },
  campaign: {
    notFound: 'کمپین یافت نشد',
    loadFailed: 'بارگذاری کمپین ناموفق بود',
    ended: 'این کمپین به پایان رسیده است.',
    notStarted: 'این کمپین هنوز شروع نشده است.',
    paused: 'این کمپین موقتاً متوقف شده است.',
    unavailable: 'این کمپین در حال حاضر در دسترس نیست.',
    noProducts: 'هنوز محصولی به این کمپین اضافه نشده است.',
    noProductsInactive: 'محصولات کمپین فقط در زمان فعال بودن نمایش داده می‌شوند.',
    productCount: '{{count}} محصول',
    visitStore: 'مشاهده {{name}}',
    viewAll: 'مشاهده همه ({{count}})',
    itemNotFound: 'آیتم کمپین یافت نشد',
    flashOffer: 'پیشنهاد ویژه',
    packOffer: 'پک کمپین',
    campaignPrice: 'قیمت کمپین',
    pricePerUnit: '{{price}} برای هر عدد',
    aboutOffer: 'درباره این پیشنهاد',
    backToCampaign: 'بازگشت به همه محصولات کمپین',
    addOfferToCart: 'افزودن پیشنهاد به سبد',
    addPackToCart: 'افزودن پک به سبد',
    notAvailableNow: 'در حال حاضر قابل خرید نیست',
  },
  orders: {
    title: 'سفارش‌های من',
    totalOrders: 'سفارش',
    noOrders: 'سفارشی یافت نشد',
    noOrdersDesc: 'هنوز سفارشی ندارید. اولین خرید خود را انجام دهید!',
    signIn: 'لطفاً وارد شوید',
    signInDesc: 'برای مشاهده سفارش‌ها وارد شوید',
    all: 'همه',
    pending: 'در انتظار پرداخت',
    processing: 'در حال پردازش',
    shipped: 'ارسال شده',
    delivered: 'تحویل داده شده',
    cancelled: 'لغو شده',
    orderedOn: 'تاریخ سفارش:',
    estDelivery: 'تحویل تقریبی:',
    viewDetails: 'مشاهده جزئیات',
    hideDetails: 'بستن جزئیات',
    track: 'ردیابی',
    orderItems: 'اقلام سفارش',
    priceDetails: 'جزئیات قیمت',
    shippingAddress: 'آدرس ارسال',
    tracking: 'کد رهگیری:',
    subtotal: 'جمع محصولات',
    shipping: 'هزینه ارسال',
    tax: 'مالیات (۱۹٪)',
    total: 'جمع کل',
    item: 'مورد',
    items: 'مورد',
    qty: 'تعداد:',
    payNow: 'پرداخت کنید',
    unknownStatus: 'وضعیت نامشخص',
    orderItemFallback: 'محصول',
    customerFallback: 'مشتری',
    stageProgress: 'مراحل سفارش',
    stagePayment: 'پرداخت',
    stagePaymentHint: 'در انتظار پرداخت',
    stagePaid: 'تأیید',
    stagePaidHint: 'پرداخت شد',
    stagePreparing: 'آماده‌سازی',
    stagePreparingHint: 'بسته‌بندی فروشگاه',
    stageShipped: 'ارسال',
    stageShippedHint: 'در مسیر تحویل',
    stageDelivered: 'تحویل',
    stageDeliveredHint: 'سفارش تکمیل شد',
    stageCurrent: 'مرحله فعلی',
    stageDone: 'انجام شد',
    refunded: 'بازپرداخت شده',
  },
  payment: {
    title: 'روش‌های پرداخت',
    manageSubtitle: 'روش‌های پرداخت را اضافه یا مدیریت کنید',
    secureEncrypted: 'اطلاعات پرداخت شما امن و رمزگذاری‌شده است',
    orderSummary: 'خلاصه سفارش',
    paymentMethod: 'روش پرداخت',
    payNow: 'پرداخت نهایی',
    processing: 'در حال اتصال به درگاه...',
    loading: 'در حال بارگذاری سفارش...',
    orderNotFound: 'سفارش یافت نشد',
    invalidOrder: 'شناسه سفارش نامعتبر است',
    invalidOrderDesc: 'سفارش مورد نظر یافت نشد. لطفاً به لیست سفارش‌ها بازگردید.',
    loadError: 'خطا در بارگذاری اطلاعات پرداخت',
    payError: 'خطا در ایجاد درگاه پرداخت',
    noCheckoutUrl: 'درگاه پرداخت در دسترس نیست',
    noItems: 'این سفارش فاقد اقلام است',
    noSavedMethods: 'هنوز روش پرداخت ذخیره نشده',
    addMethod: 'افزودن روش پرداخت',
    addPaymentMethod: 'افزودن روش پرداخت',
    savePaymentMethod: 'ذخیره روش پرداخت',
    addPaymentMethodTitle: 'افزودن روش پرداخت',
    card: 'کارت',
    bankTransfer: 'انتقال بانکی',
    default: 'پیش‌فرض',
    unknownMethod: 'روش ناشناس',
    secureDesc: 'پرداخت امن با رمزگذاری SSL',
    saved: 'ذخیره شده',
    method: 'روش',
    methods: 'روش',
    addNew: 'افزودن جدید',
    noPaymentMethods: 'هنوز روش پرداختی ندارید',
    noPaymentMethodsDesc: 'اولین روش پرداخت خود را اضافه کنید',
    setDefault: 'پیش‌فرض کنید',
    deletePaymentMethod: 'حذف روش پرداخت؟',
    deleteDesc: 'آیا مطمئنید که می‌خواهید این روش پرداخت را حذف کنید؟ این عمل قابل بازگشت نیست.',
    backToProfile: 'بازگشت به پروفایل',
    paypal: 'پی‌پال',
    bank: 'بانک',
    cardNumber: 'شماره کارت',
    cardHolder: 'نام دارنده کارت',
    expiryDate: 'تاریخ انقضا',
    cvv: 'CVV',
    cardType: 'نوع کارت',
    paypalEmail: 'ایمیل پی‌پال',
    bankName: 'نام بانک',
    accountNumber: 'شماره حساب',
    setAsDefault: 'به عنوان روش پرداخت پیش‌فرض',
    cardHolder_placeholder: 'نام روی کارت',
    editPaymentMethod: 'ویرایش روش پرداخت',
    saveChanges: 'ذخیره تغییرات',
    expires: 'انقضا',
    cardHolderLabel: 'دارنده کارت',
  },
  profile: {
    title: 'پروفایل',
    backToHome: 'بازگشت به خانه',
    editProfile: 'ویرایش پروفایل',
    saveChanges: 'ذخیره تغییرات',
    memberSince: 'عضو بازارک از',
    welcomeBack: 'خوش برگشتی، {{name}}',
    email: 'ایمیل',
    phone: 'تلفن',
    address: 'آدرس',
    birthDate: 'تاریخ تولد',
    birthDateHint: 'اسکرول کنید و تاریخ تولد را انتخاب کنید',
    day: 'روز',
    month: 'ماه',
    year: 'سال',
    myOrders: 'سفارش‌های من',
    viewAllPurchases: 'مشاهده همه',
    savedItems: 'مورد ذخیره شده',
    manageLocations: 'مدیریت مکان‌ها',
    savedCards: 'کارت‌های ذخیره شده',
    preferences: 'ترجیحات',
    passwordAnd2FA: 'رمز عبور و تأیید دو مرحله‌ای',
    language: 'زبان',
    helpSupport: 'پشتیبانی ۲۴/۷',
    logout: 'خروج',
    confirmLogout: 'تایید خروج',
    confirmLogoutDesc: 'آیا مطمئنید که می‌خواهید از حساب خود خارج شوید؟',
    uploadProfilePicture: 'آپلود تصویر پروفایل',
    clickToUpload: 'برای آپلود کلیک کنید یا فایل را بکشید',
    chooseFile: 'انتخاب فایل',
    version: 'بازارک نسخه ۱.۰.۰',
    terms: 'شرایط',
    privacy: 'حریم خصوصی',
    backToProfile: 'بازگشت به پروفایل',
    imageTooLarge: 'حجم تصویر نباید بیشتر از ۵ مگابایت باشد',
    yourPoints: 'امتیاز شما',
    yourLevel: 'سطح شما',
    levelBronze: 'برنز',
    levelSilver: 'نقره',
    levelGold: 'طلا',
    levelDiamond: 'الماس',
    levelLegend: 'افسانه',
    pointsToNext: 'برای سطح بعدی {{count}} امتیاز دیگر لازم دارید',
    maxLevel: 'به بالاترین سطح رسیده‌اید',
    memberOfSince: 'عضو بازارک از {{date}}',
    proTitle: 'بازارک پرو',
    proDesc: 'تجربه‌ای لوکس‌تر با مزایای ویژه',
    proUpgrade: 'ارتقا به پرو',
    proExtend: 'تمدید پرو',
    proActive: 'فعال',
    proActivated: 'عضویت پرو فعال شد',
    proActiveUntil: 'فعال تا {{date}}',
    proBenefitShipping: 'ارسال رایگان',
    proBenefitDiscounts: 'تخفیف‌های اختصاصی',
    proBenefitSupport: 'پشتیبانی ویژه',
    proBenefitReturns: 'مرجوعی رایگان',
    proComingSoon: 'عضویت پرو به‌زودی فعال می‌شود',
    inviteTitle: 'دعوت از دوستان',
    inviteDesc: 'دوستانت را دعوت کن و امتیاز و جوایز بگیر',
    inviteCode: 'کد دعوت شما',
    inviteCta: 'دعوت و کسب امتیاز',
    inviteCopied: 'کد دعوت کپی شد',
    enterInviteCode: 'وارد کردن کد دعوت',
    applyInvite: 'ثبت کد',
    referralApplied: 'پاداش دعوت اعمال شد',
    referralBonusHint: 'شما و دوستتان هر کدام {{count}} امتیاز می‌گیرید',
    shareInviteText: 'با کد دعوت من به بازارک بپیوند: {{code}}',
    orderAll: 'همه سفارش‌ها',
    orderProcessing: 'در حال پردازش',
    orderShipped: 'ارسال شده',
    orderDelivered: 'تحویل شده',
    orderReturns: 'مرجوعی‌ها',
    accountInfo: 'اطلاعات حساب',
    giftCards: 'کارت‌های هدیه',
    giftCardsSoon: 'کارت هدیه به‌زودی اضافه می‌شود',
    supportHelp: 'پشتیبانی و کمک',
    settings: 'تنظیمات',
    levelPlatinum: 'پلاتین',
    pullForMemberPass: 'بکش پایین — پاس ویژه اعضا',
    pullToHidePass: 'بکش بالا برای بستن پاس',
    memberPassEyebrow: 'باشگاه اعضا',
    memberPassTitle: 'Bazaarak — Bringing Home Closer',
    memberPassSubtitle: 'سطح {{level}} شما برای تخفیف‌ها و رویدادهای ویژه',
    yourQrCode: 'کد QR شما',
    scanToInvite: 'با اسکن این کد، دوستانت با دعوت شما ثبت‌نام می‌کنند',
    festivalPerksTitle: 'مزایای جشنواره‌ای شما',
    festivalPerkAccess: 'دسترسی به بخش جشنواره',
    festivalPerkDiscount: 'تخفیف ویژه جشنواره',
    festivalPerkGift: 'هدیه و بسته‌بندی ویژه',
    festivalPerkPoints: 'امتیاز مضاعف در جشنواره',
    festivalPerkVip: 'ورود VIP به رویدادها',
    festivalPerkEarly: 'دسترسی زودهنگام به حراج‌ها',
  },
  gift: {
    title: 'گیفت کارت',
    balanceLabel: 'موجودی گیفت کارت',
    useCta: 'استفاده از گیفت کارت',
    sendTitle: 'ارسال گیفت کارت',
    sendHint: 'برای دوستان و عزیزان',
    buyTitle: 'خرید گیفت کارت',
    buyHint: 'هدیه‌ای برای هر لحظه',
    buyForSelfOrOthers: 'برای خود یا دیگران',
    customAmount: 'مبلغ دلخواه',
    enterCustomAmount: 'مبلغ را وارد کنید',
    sendForLovedOnes: 'هدیه‌ای برای عزیزان',
    recipientContact: 'شماره موبایل یا ایمیل گیرنده',
    congratsMessage: 'پیام تبریک (اختیاری)',
    contactRequired: 'شماره موبایل یا ایمیل گیرنده را وارد کنید',
    selectAmountFirst: 'ابتدا مبلغ را انتخاب کنید',
    amountInvalid: 'مبلغ معتبر وارد کنید',
    historyTitle: 'تاریخچه گیفت کارت‌ها',
    secureTitle: 'گیفت کارت ایمن و مطمئن',
    secureDesc: 'گیفت کارت‌ها امن و قابل اعتماد هستند و برای کمک با پشتیبانی تماس بگیرید.',
    received: 'دریافت گیفت کارت',
    used: 'استفاده از گیفت کارت',
    sent: 'ارسال گیفت کارت',
    receivedFromBrand: 'دریافت گیفت کارت',
    fromPerson: 'از طرف {{name}}',
    toPerson: 'برای {{name}}',
    orderNo: 'سفارش شماره {{id}}',
    buyDesc: 'مبلغ مورد نظر برای افزایش موجودی را انتخاب کنید.',
    selectedAmount: 'مبلغ انتخاب‌شده',
    confirmBuy: 'خرید',
    buySuccess: 'گیفت کارت خریداری شد',
    sendDesc: 'بخشی از موجودی گیفت کارت را برای کسی بفرستید.',
    available: 'موجودی',
    recipientName: 'نام گیرنده',
    recipientPhone: 'شماره تماس (اختیاری)',
    amount: 'مبلغ',
    message: 'پیام (اختیاری)',
    confirmSend: 'ارسال گیفت کارت',
    sendSuccess: 'گیفت کارت ارسال شد',
    nameRequired: 'نام گیرنده را وارد کنید',
    insufficient: 'موجودی گیفت کارت کافی نیست',
    useTitle: 'استفاده از گیفت کارت',
    redeemDesc: 'کد گیفت کارت را وارد کنید تا به موجودی اضافه شود.',
    code: 'کد گیفت کارت',
    confirmRedeem: 'اعمال کد',
    redeemSuccess: 'گیفت کارت اعمال شد',
    codeInvalid: 'کد گیفت کارت معتبر وارد کنید',
    noHistory: 'هنوز فعالیتی ثبت نشده',
    infoTitle: 'درباره گیفت کارت',
    info1: 'گیفت کارت بخرید یا برای دوستان بفرستید. اعتبار در کیف پول بازارک می‌ماند.',
    info2: 'می‌توانید کد را وارد کنید، تاریخچه را ببینید و در سفارش‌های مجاز استفاده کنید.',
    info3: 'کمک لازم دارید؟ از پروفایل با پشتیبانی تماس بگیرید.',
  },
  wishlist: {
    title: 'علاقه‌مندی‌های من',
    saved: 'ذخیره شده',
    totalValue: 'ارزش کل',
    potentialSavings: 'صرفه‌جویی احتمالی',
    inStock: 'موجود',
    addToCart: 'افزودن به سبد',
    addAllToCart: 'افزودن همه به سبد',
    shareWishlist: 'اشتراک‌گذاری',
    empty: 'علاقه‌مندی‌های شما خالی است',
    emptyDesc: 'محصولاتی که دوست دارید را اضافه کنید',
    startShopping: 'شروع خرید',
    signIn: 'لطفاً وارد شوید',
    signInDesc: 'برای مشاهده علاقه‌مندی‌ها وارد شوید',
    removedFromWishlist: 'از علاقه‌مندی‌ها حذف شد',
    failedToLoad: 'بارگذاری علاقه‌مندی‌ها ناموفق بود',
    backToProfile: 'بازگشت به پروفایل',
  },
  vendor: {
    dashboard: 'داشبورد فروشنده',
    manageDashboard: 'فروشگاه خود را مدیریت و عملکرد را دنبال کنید',
    editStore: 'ویرایش فروشگاه',
    addProduct: 'افزودن محصول',
    createStory: 'ایجاد استوری',
    overview: 'نمای کلی',
    overviewTab: 'نمای کلی',
    productsTab: 'محصولات',
    storiesTab: 'استوری‌ها',
    campaignsTab: 'کمپین‌ها',
    joinCampaigns: 'پیوستن به کمپین',
    myCampaigns: 'کمپین‌های من',
    activeCampaigns: 'کمپین‌های فعال',
    howItWorks: 'چطور کار می‌کند؟',
    conditions: 'شرایط',
    eligibleProducts: 'محصولات واجد شرایط',
    addProducts: 'افزودن محصول',
    campaignCondDiscount: 'حداقل ۱۰٪ تخفیف',
    campaignCondStock: 'موجودی کافی',
    campaignCondShip: 'ارسال از انبار شما',
    howCampaignsWork: 'کمپین‌ها چطور کار می‌کنند؟',
    howCampaignsWorkDesc:
      'به کمپین‌های پلتفرم بپیوندید، محصولات واجد شرایط را با تخفیف لازم اضافه کنید و دیده شوید.',
    tipsForBetterResults: 'نکات برای نتیجه بهتر',
    tipPricing: 'قیمت‌گذاری رقابتی',
    tipStock: 'موجودی کافی',
    tipDelivery: 'ارسال سریع',
    payouts: 'پرداخت‌ها',
    paymentsTab: 'Payments',
    deliveriesTab: 'Deliveries',
    analyticsTab: 'تحلیل‌ها',
    totalSales: 'کل فروش',
    orders: 'سفارش‌ها',
    products: 'محصولات',
    customers: 'مشتریان',
    recentOrders: 'سفارش‌های اخیر',
    viewAll: 'مشاهده همه',
    inventoryAlerts: 'هشدارهای موجودی',
    manageInventory: 'مدیریت موجودی',
    myStories: 'استوری‌های من',
    stories: 'استوری',
    editStoreInfo: 'ویرایش اطلاعات فروشگاه',
    addNewProduct: 'افزودن محصول جدید',
    editProduct: 'ویرایش محصول',
    createNewStory: 'ایجاد استوری جدید',
    editStory: 'ویرایش استوری',
    stripeAlertTitle: 'حساب Stripe متصل نیست',
    stripeAlertDesc: 'برای دریافت درآمد از فروش محصولات، ابتدا حساب Stripe خود را متصل کنید. بدون آن امکان ثبت محصول وجود ندارد.',
    stripeConnectBtn: 'اتصال حساب Stripe',
    stripeConnecting: 'در حال اتصال...',
    stripeNoEmail: 'ایمیل فروشگاه تنظیم نشده است. ابتدا ایمیل را در تنظیمات فروشگاه وارد کنید.',
    stripeConnectFailed: 'اتصال به Stripe ناموفق بود. لطفاً دوباره تلاش کنید.',
    stripeStatusTitle: 'وضعیت Stripe',
    stripeNotConnected: 'حساب Stripe متصل نیست',
    stripeActive: 'فعال',
    stripeInactive: 'غیرفعال',
    stripeCanSell: 'می‌توانید محصول بفروشید',
    stripeCannotSell: 'هنوز نمی‌توانید محصول بفروشید',
    stripeAccountId: 'شناسه اکانت',
    stripeContinueOnboarding: 'ادامه Onboarding',
    stripeResetBtn: 'ریست Stripe',
    stripeResetTitle: 'ریست اکانت Stripe',
    stripeResetDesc: 'آیا مطمئن هستید؟ این کار اکانت Stripe شما را حذف می‌کند و باید از اول وصل کنید.',
    stripeResetConfirm: 'بله، ریست کن',
    stripeResetting: 'در حال ریست...',
    stripeResetFailed: 'ریست Stripe ناموفق بود',
    stripeProductsBlockTitle: 'برای ثبت محصول، Stripe را متصل کنید',
    stripeProductsBlockDesc: 'فروشگاه شما هنوز به Stripe متصل نشده است. ابتدا از داشبورد اصلی اتصال را انجام دهید.',
    stripeBlockTitle: 'نیاز به اتصال Stripe',
    stripeBlockDesc: 'برای اینکه بتوانید محصول ثبت کنید و درآمد کسب کنید، ابتدا باید حساب Stripe خود را متصل کنید.',
    dashboardWidgets: 'ویجت‌های داشبورد',
    dashboardWidgetsHint: 'کارت‌هایی که در نمای کلی نمایش داده می‌شوند را انتخاب کنید.',
    widgetStoreHealth: 'سلامت فروشگاه',
    widgetTotalSales: 'نمودار کل فروش',
    widgetOrdersCustomers: 'سفارش‌ها و مشتریان',
    widgetProductsSummary: 'خلاصه محصولات',
    widgetSalesPerformance: 'عملکرد فروش',
    widgetOrderStatus: 'وضعیت سفارش‌ها',
    widgetTopProducts: 'پرفروش‌ترین محصولات',
    widgetStoreInsights: 'بینش فروشگاه',
    storeHealth: 'سلامت فروشگاه',
    storeActive: 'فروشگاه فعال',
    storeSetup: 'نیاز به تکمیل',
    sinceLabel: 'از ژانویه ۲۰۲۴',
    profileComplete: 'پروفایل کامل',
    productsActive: 'محصولات فعال',
    goodPerformance: 'عملکرد خوب',
    setLocation: 'تنظیم موقعیت فروشگاه',
    vsLastMonth: 'نسبت به ماه قبل',
    last7Days: '۷ روز اخیر',
    last30Days: '۳۰ روز اخیر',
    salesPerformance: 'عملکرد فروش',
    orderStatus: 'وضعیت سفارش‌ها',
    topSellingProducts: 'پرفروش‌ترین محصولات',
    storeInsights: 'بینش فروشگاه',
    activeProducts: 'فعال',
    lowInStock: 'موجودی کم',
    insightLowStock: '{{count}} محصول موجودی کمی دارند.',
    insightStockOk: 'سطح موجودی مناسب به نظر می‌رسد.',
    insightSalesUp: 'فروش شما این هفته ۲۴٪ افزایش یافته است.',
    insightOrdersAttention: '{{count}} سفارش نیاز به توجه شما دارند.',
    fillRequired: 'لطفاً همه فیلدهای ضروری را پر کنید',
    saveFailed: 'ذخیره محصول ناموفق بود',
    deleteFailed: 'حذف محصول ناموفق بود',
    storeNameLabel: 'نام فروشگاه',
    storeDescLabel: 'توضیحات فروشگاه',
    ordersEmpty: 'سفارشی ثبت نشده است',
    salesLabel: 'فروش',
    stockLeft: 'باقی‌مانده',
    lowStock: 'موجودی کم',
    revenueLabel: 'درآمد',
    categoryLabel: 'دسته‌بندی',
    orderLabel: 'سفارش',
    itemsLabel: 'اقلام',
    guestCustomer: 'مشتری مهمان',
    noProductsYet: 'هنوز محصولی ندارید',
    addProductDesc: 'اولین محصول خود را اضافه کنید تا فروش خود را آغاز کنید',
    productNameLabel: 'نام محصول',
    productNamePlaceholder: 'نام محصول را وارد کنید',
    otherCategory: 'سایر',
    productDescPlaceholder: 'توضیحات محصول را وارد کنید...',
    productImageLabel: 'تصویر محصول',
    uploading: 'در حال آپلود...',
    uploadImage: 'آپلود تصویر',
    deleteProductTitle: 'حذف محصول؟',
    deleteProductDesc: 'آیا مطمئنید که می‌خواهید حذف کنید',
    noProducts: 'هنوز محصولی ندارید',
    uploadNetworkError: 'آپلود تصویر از طریق سرور امکان‌پذیر نیست. لطفاً لینک تصویر را وارد کنید.',
    useImageUrl: 'لینک تصویر',
    hideUrl: 'بستن لینک',
    imageUrlHint: 'اگر آپلود تصویر کار نمی‌کند، لینک مستقیم تصویر را وارد کنید:',
    imageUrlPlaceholder: '/uploads/example.jpg',
    applyUrl: 'اعمال',
  },
  notifications: {
    title: 'اعلانات',
    subtitle: 'با آخرین فعالیت‌ها به‌روز بمان',
    unread: 'خوانده نشده',
    markAllRead: 'همه را خوانده‌شده علامت بزن',
    allNotifications: 'همه',
    unreadNotifications: 'خوانده نشده',
    noNotifications: 'اعلانی وجود ندارد',
    noNotificationsDesc: 'همه چیز آپدیت است! بعداً برگردید.',
    markRead: 'علامت خواندن',
    today: 'امروز',
    yesterday: 'دیروز',
    earlier: 'قبلی‌ها',
    settingsTitle: 'تنظیمات اعلان‌ها',
    settingsSubtitle: 'چیزی که می‌بینی و چطور خبردار می‌شی را مدیریت کن',
    pushTitle: 'اعلان‌های پوش',
    pushDesc: 'دریافت اعلان روی دستگاه',
    preferences: 'ترجیحات اعلان',
    prefOrders: 'سفارش و ارسال',
    prefOrdersDesc: 'به‌روزرسانی سفارش و ارسال',
    prefPromos: 'تخفیف و پیشنهادها',
    prefPromosDesc: 'تخفیف‌ها و پیشنهادهای ویژه',
    prefAlerts: 'هشدار و یادآوری',
    prefAlertsDesc: 'کاهش قیمت و یادآوری‌های مهم',
    prefMessages: 'پیام‌ها',
    prefMessagesDesc: 'چت و پیام‌های پشتیبانی',
    prefWishlist: 'علاقه‌مندی‌ها',
    prefWishlistDesc: 'تغییر یا کاهش قیمت علاقه‌مندی‌ها',
    prefPayment: 'پرداخت و صورتحساب',
    prefPaymentDesc: 'تأیید پرداخت و هشدار صورتحساب',
    channels: 'کانال‌های اعلان',
    channelPush: 'اعلان پوش',
    channelPushDesc: 'اعلان فوری روی دستگاه',
    channelEmail: 'اعلان ایمیل',
    channelEmailDesc: 'دریافت به‌روزرسانی با ایمیل',
    channelSms: 'اعلان پیامک',
    channelSmsDesc: 'هشدارهای مهم با پیامک',
    primary: 'اصلی',
    dailyDigest: 'خلاصه روزانه',
    instant: 'فوری',
    off: 'خاموش',
    important: 'مهم',
    inControl: 'همه‌چیز دست خودته',
    inControlDesc: 'هر وقت خواستی ترجیحات را عوض کن.',
  },
  addresses: {
    title: 'آدرس‌های من',
    yourAddresses: 'آدرس‌های شما',
    yourSavedAddresses: 'آدرس‌های ذخیره‌شده',
    savedCount: 'شما {{count}} آدرس ذخیره دارید',
    manageHint: 'آدرس‌های تحویل را مدیریت کنید.',
    secureTitle: 'امن و خصوصی',
    secureDesc: 'آدرس‌هایتان نزد ما امن است و فقط برای ارسال استفاده می‌شود.',
    saved: 'ذخیره شده',
    location: 'مکان',
    locations: 'مکان',
    addNew: 'افزودن جدید',
    noAddresses: 'هنوز آدرسی ندارید',
    noAddressesDesc: 'اولین آدرس تحویل خود را اضافه کنید',
    addAddress: 'افزودن آدرس',
    signIn: 'لطفاً وارد شوید',
    signInDesc: 'برای مدیریت آدرس‌ها وارد شوید',
    addNewAddress: 'افزودن آدرس جدید',
    editAddress: 'ویرایش آدرس',
    deleteAddress: 'حذف آدرس؟',
    deleteAddressDesc: 'آیا مطمئنید که می‌خواهید حذف کنید',
    cannotBeUndone: 'این عمل قابل بازگشت نیست.',
    setDefault: 'پیش‌فرض کنید',
    backToProfile: 'بازگشت به پروفایل',
    default: 'پیش‌فرض',
    label: 'برچسب آدرس',
    street: 'آدرس خیابان',
    city: 'شهر',
    state: 'استان',
    zip: 'کد پستی',
    country: 'کشور',
    mapPreview: 'پیش‌نمایش نقشه',
    saveAddress: 'ذخیره آدرس',
    searchPlaceholder: 'آدرس خود را جستجو کنید...',
    labelPlaceholder: 'خانه، محل کار...',
    typeHome: 'خانه',
    typeWork: 'محل کار',
    typeOther: 'سایر',
    tapMapHint: 'برای تنظیم دقیق موقعیت روی نقشه کلیک کنید',
    tapMapAdjust: 'برای جابجایی پین روی نقشه کلیک کنید',
    switchToSearch: 'برای افزودن آدرس به تب جستجو بروید',
    searchFailed: 'جستجو ناموفق بود. دوباره تلاش کنید.',
    addressFallback: 'آدرس',
    searchTab: 'جستجو',
    savedTab: 'ذخیره شده',
    resultsFound: 'نتیجه',
    startTypingHint: 'آدرس خود را تایپ کنید...',
    namePlaceholder: 'نام و نام خانوادگی خود را وارد کنید',
    phonePlaceholder: '۰۹۱۲۳۴۵۶۷۸۹',
    autoFilledHint: 'فیلدهای آدرس به صورت خودکار پر شده‌اند. می‌توانید ویرایش کنید.',
    editPin: 'ویرایش پین',
    confirmPin: 'تأیید موقعیت',
    locationType: 'نوع مکان',
    selectLocationType: 'نوع مکان را انتخاب کنید',
    apartment: 'آپارتمان',
    house: 'خانه',
    office: 'اداره',
    outdoor: 'فضای باز / ملاقات',
    elsewhere: 'سایر',
    doorbellName: 'اسم روی زنگوله',
    doorbellNamePlaceholder: 'مثلاً "علی احمدی"',
    entrance: 'ورودی',
    entrancePlaceholder: 'مثلاً "ورودی B"',
    additionalInfo: 'اطلاعات تکمیلی',
    additionalInfoPlaceholder: 'راهنمایی برای پیک...',
    floor: 'طبقه',
    floorPlaceholder: 'مثلاً "۳"',
    elevator: 'آسانسور دارد؟',
    deliveryAddress: 'آدرس تحویل',
    deliveryDetails: 'جزئیات تحویل',
    addressRequired: 'لطفاً یک آدرس انتخاب کنید',
    phoneRequired: 'شماره تماس الزامی است',
  },
  security: {
    title: 'تنظیمات امنیتی',
    manageDesc: 'امنیت حساب خود را مدیریت کنید',
    changePassword: 'تغییر رمز عبور',
    changePasswordDesc: 'رمز عبور حساب خود را به‌روز کنید',
    twoFA: 'تأیید دو مرحله‌ای',
    twoFADesc: 'یک لایه امنیتی اضافی اضافه کنید',
    biometric: 'ورود بیومتریک',
    biometricDesc: 'ورود با اثر انگشت یا چهره',
    activeSessions: 'جلسات فعال',
    activeDevices: '{{count}} دستگاه فعال',
    loginHistory: 'تاریخچه ورود',
    viewRecentActivity: 'مشاهده فعالیت اخیر حساب',
    deleteAccount: 'حذف حساب',
    deleteDesc: 'حذف دائمی حساب',
    permanentlyDelete: 'حذف دائمی حساب کاربری',
    accountProtected: 'حساب شما محافظت می‌شود',
    dataSafe: 'داده‌هایتان را امن نگه می‌داریم.',
    on: 'روشن',
    off: 'خاموش',
    recentLoginActivity: 'فعالیت ورود اخیر',
    enable2FA: 'فعال‌سازی تأیید دو مرحله‌ای',
    disable2FA: 'غیرفعال‌سازی تأیید دو مرحله‌ای',
    sessions: 'دستگاه فعال',
    enable2FATitle: 'فعال‌سازی تأیید دو مرحله‌ای',
    disable2FATitle: 'غیرفعال‌سازی تأیید دو مرحله‌ای',
    enable2FADesc: 'یک لایه امنیتی اضافی با تأیید دو مرحله‌ای به حساب خود اضافه کنید.',
    disable2FADesc: 'بدون تأیید دو مرحله‌ای حساب شما امنیت کمتری خواهد داشت.',
    activeSessionsTitle: 'جلسات فعال',
    updatePassword: 'به‌روزرسانی رمز عبور',
    currentPassword: 'رمز عبور فعلی',
    newPassword: 'رمز عبور جدید',
    confirmPassword: 'تأیید رمز عبور جدید',
    enterCurrentPassword: 'رمز عبور فعلی را وارد کنید',
    enterNewPassword: 'رمز عبور جدید را وارد کنید',
    confirmNewPassword: 'رمز عبور جدید را تأیید کنید',
    passwordsDoNotMatch: 'رمزهای عبور مطابقت ندارند!',
    passwordMinLength: 'رمز عبور باید حداقل ۸ کاراکتر باشد!',
    scanQRCode: 'اسکن کد QR',
    useAuthenticator: 'از Google Authenticator یا برنامه مشابه استفاده کنید',
    success: 'موفق',
    failed: 'ناموفق',
    backToProfile: 'بازگشت به پروفایل',
    current: 'فعلی',
    logout: 'خروج',
    deleteAccountTitle: 'حذف حساب',
    deleteAccountDesc: 'این عمل قابل بازگشت نیست. تمام داده‌های شما به طور دائم حذف می‌شود.',
    deleteWarning: '• همه سفارش‌ها و تاریخچه خرید حذف می‌شوند\n• آدرس‌ها و روش‌های پرداخت حذف می‌شوند\n• علاقه‌مندی‌ها از بین می‌روند\n• این عمل غیرقابل بازگشت است',
  },
  help: {
    title: 'راهنما و پشتیبانی',
    subtitle: 'ما ۲۴/۷ اینجاییم تا کمک کنیم',
    chooseOption: 'یک گزینه پشتیبانی انتخاب کنید',
    quickHelp: 'راهنمای سریع',
    faqsShort: 'سوالات متداول',
    accountOrders: 'حساب و سفارش‌ها',
    paymentsRefunds: 'پرداخت و استرداد',
    hereForYou: 'ما اینجاییم برات',
    hereForYouDesc: 'تیم پشتیبانی همیشه آماده‌ست کمک کنه و مشکلت رو حل کنه.',
    liveChat: 'چت زنده',
    liveChatDesc: 'با تیم پشتیبانی ما چت کنید',
    available247: 'در دسترس ۲۴/۷',
    emailSupport: 'پشتیبانی ایمیل',
    emailSupportDesc: 'support@bazarak.com',
    responseTime: 'پاسخ در ۲۴ ساعت',
    phoneSupport: 'پشتیبانی تلفنی',
    phoneSupportDesc: '+۴۹ ۳۰ ۱۲۳۴ ۵۶۷۸',
    monFri: 'دوشنبه تا جمعه، ۹ صبح تا ۶ عصر',
    whatsapp: 'واتس‌اپ',
    whatsappDesc: 'در واتس‌اپ پیام بدهید',
    faq: 'سوالات متداول',
    allTopics: 'همه موضوعات',
    orders: 'سفارش‌ها',
    payments: 'پرداخت‌ها',
    shipping: 'ارسال',
    returns: 'مرجوعی',
    account: 'حساب',
    quickLinks: 'لینک‌های سریع',
    terms: 'شرایط خدمات',
    privacy: 'حریم خصوصی',
    refund: 'سیاست استرداد',
    shippingPolicy: 'سیاست ارسال',
    stillNeedHelp: 'هنوز به کمک نیاز دارید؟',
    stillNeedHelpDesc: 'چیزی که دنبالش هستید پیدا نکردید؟ تیم پشتیبانی ما آماده کمک است.',
    contactSupport: 'تماس با پشتیبانی',
    contactSupportTitle: 'تماس با پشتیبانی',
    yourName: 'نام شما',
    emailAddress: 'آدرس ایمیل',
    subject: 'موضوع',
    message: 'پیام',
    sendMessage: 'ارسال پیام',
    noFaqFound: 'سوالی در این دسته‌بندی یافت نشد',
    startChat: 'شروع چت',
    sendEmail: 'ارسال ایمیل',
    callNow: 'تماس',
    openWhatsApp: 'باز کردن واتس‌اپ',
    backToProfile: 'بازگشت به پروفایل',
    subjectPlaceholder: 'چطور می‌توانیم کمک کنیم؟',
    messagePlaceholder: 'مشکل خود را با جزئیات توضیح دهید...',
    namePlaceholder: 'نام خود را وارد کنید',
  },
  footer: {
    quickLinks: 'لینک‌های سریع',
    support: 'پشتیبانی',
    downloadApp: 'دانلود اپلیکیشن',
    description: 'بازارک، فروشگاه آنلاین محصولات تازه و باکیفیت. تضمین بهترین قیمت و سریع‌ترین ارسال.',
    rights: '© ۲۰۲۶ بازارک. تمامی حقوق محفوظ است.',
    contactUs: 'تماس با ما',
    terms: 'شرایط استفاده',
    privacy: 'حریم خصوصی',
    helpCenter: 'مرکز راهنمایی',
    appStore: 'App Store',
    googlePlay: 'Google Play',
  },
  language: {
    title: 'زبان',
    persian: 'فارسی',
    english: 'English',
    german: 'Deutsch',
    turkish: 'Türkçe',
    arabic: 'العربی',
    selectLanguage: 'انتخاب زبان',
    currentLanguage: 'زبان فعلی',
    availableLanguages: 'زبان‌های موجود',
    changeInfo: 'تغییر زبان، رابط کل اپلیکیشن را بلافاصله به‌روز می‌کند.',
    switchConfirm: 'تغییر به {{name}} ({{native}})؟',
  },
  datetime: {
    title: 'زمان‌بندی تحویل',
    quickSelect: 'انتخاب سریع',
    selectDate: 'انتخاب تاریخ',
    selectTime: 'انتخاب زمان',
    today: 'امروز',
    tomorrow: 'فردا',
    dayAfter: 'پس‌فردا',
    nextWeek: 'هفته آینده',
    su: 'ی',
    mo: 'د',
    tu: 'س',
    we: 'چ',
    th: 'پ',
    fr: 'ج',
    sa: 'ش',
    deliveryTo: 'ارسال به',
    pickupFrom: 'تحویل حضوری از',
    courierArrives: 'پیک در این بازه زمانی خواهد رسید',
    readyForPickup: 'سفارش شما برای تحویل حضوری آماده خواهد بود',
    confirmSchedule: 'تایید زمان‌بندی',
    selectDateTime: 'تاریخ و زمان را انتخاب کنید',
    selectAndConfirm: 'انتخاب و تایید کنید',
    morning: 'صبح',
    noon: 'ظهر',
    afternoon: 'عصر',
    evening: 'شب',
  },
  bazaarHub: {
    title: 'بازارک',
    subtitle: 'همه چیز در یک جا',
    categories: 'دسته‌بندی‌ها',
    search: 'جستجو',
    cart: 'سبد خرید',
    orders: 'سفارش‌ها',
    profile: 'پروفایل',
    wishlist: 'علاقه‌مندی‌ها',
    offers: 'آفرها',
    vendors: 'فروشگاه‌ها',
    addresses: 'آدرس‌ها',
    notifications: 'اعلانات',
    settings: 'تنظیمات',
    help: 'راهنما',
  },
  theme: {
    darkMode: 'حالت تاریک',
    lightMode: 'حالت روشن',
  },
  search: {
    productLabel: 'محصولات',
    categoryLabel: 'دسته‌بندی‌ها',
    wishlistLabel: 'علاقه‌مندی‌ها',
    offerLabel: 'آفرها',
    addressLabel: 'آدرس‌ها',
    vendorLabel: 'فروشگاه‌ها',
    mapView: 'نمایش روی نقشه',
    listView: 'نمایش لیست',
    nearMe: 'نزدیک من',
    searchLocation: 'جستجو در محدوده...',
    filteringBy: 'فیلتر بر اساس',
    clearCategoryFilter: 'حذف فیلتر دسته‌بندی',
    relevance: 'مرتبط‌ترین',
    priceLowToHigh: 'قیمت: کم به زیاد',
    priceHighToLow: 'قیمت: زیاد به کم',
    newest: 'جدیدترین',
    topRated: 'بالاترین امتیاز',
    allPrices: 'همه قیمت‌ها',
    allRatings: 'همه امتیازها',
    sortBy: 'مرتب‌سازی',
    priceRange: 'بازه قیمت',
    rating: 'امتیاز',
    filters: 'فیلترها',
    applyFilters: 'اعمال فیلترها',
    clearAllFilters: 'حذف همه فیلترها',
    brand: 'برند',
    color: 'رنگ',
    size: 'سایز',
    allBrands: 'همه برندها',
    allColors: 'همه رنگ‌ها',
    allSizes: 'همه سایزها',
    noBrands: 'برندی موجود نیست',
    noColors: 'رنگی موجود نیست',
    noSizes: 'سایزی موجود نیست',
    typeToFind: 'برای یافتن محصولات، دسته‌بندی‌ها و بیشتر تایپ کنید',
    for: 'برای',
    resultsFor: 'نتایج جستجو برای',
    resultsFound: 'نتیجه یافت شد',
    items: 'کالاها',
    stores: 'فروشگاه‌ها',
    categories: 'دسته‌بندی‌ها',
    itemFound: 'کالا',
    storeFound: 'فروشگاه',
    categoryFound: 'دسته‌بندی',
    tryDifferentKeywords: 'با کلمات دیگری جستجو کنید',
    noProductsFound: 'کالایی یافت نشد',
    noStoresFound: 'فروشگاهی یافت نشد',
    noCategoriesFound: 'دسته‌بندی‌ای یافت نشد',
  },
  aiAssistant: {
    title: 'دستیار هوشمند',
    subtitle: 'چطور می‌تونم کمکتون کنم؟',
    hotDeals: 'تخفیف‌های داغ',
    trackOrder: 'ردیابی سفارش',
    popular: 'محبوب‌ترین‌ها',
    findStores: 'پیدا کردن فروشگاه',
    comingSoon: 'قابلیت‌های هوشمند AI به زودی!',
    askAnything: 'هر چیزی بپرسید...',
    errorReply: 'متأسفانه مشکلی پیش اومد. دوباره تلاش کنید.',
  },
  stores: {
    title: 'همه فروشگاه‌ها',
    stores: 'فروشگاه',
    searchPlaceholder: 'جستجو در فروشگاه‌ها بر اساس نام، شهر یا برچسب...',
    sortPopular: 'محبوب‌ترین',
    sortRating: 'بالاترین امتیاز',
    sortNewest: 'جدیدترین',
    sortProducts: 'بیشترین محصول',
    endOfList: 'پایان لیست',
    products: 'محصول',
    reviews: 'نظر',
  },
  errors: {
    loadFailed: 'بارگذاری داده‌ها ناموفق بود. لطفاً دوباره تلاش کنید.',
    noResults: 'نتیجه‌ای یافت نشد',
    uploadFailed: 'آپلود تصویر ناموفق بود. لطفاً دوباره تلاش کنید.',
  },
  admin: {
    title: 'پنل مدیریت',
    menu: 'منو',
    backToSite: 'بازگشت به سایت',
    dashboard: 'داشبورد',
    users: 'کاربران',
    stores: 'فروشگاه‌ها',
    products: 'محصولات',
    orders: 'سفارش‌ها',
    categories: 'دسته‌بندی‌ها',
    search: 'جستجو در این بخش...',
    totalUsers: 'کل کاربران',
    totalStores: 'کل فروشگاه‌ها',
    totalProducts: 'کل محصولات',
    totalOrders: 'کل سفارش‌ها',
    totalRevenue: 'درآمد کل',
    pendingOrders: 'سفارش‌های در انتظار',
    quickActions: 'عملیات سریع',
    addCategory: 'افزودن دسته‌بندی',
    addProduct: 'افزودن محصول',
    viewOrders: 'مشاهده سفارش‌ها',
    manageUsers: 'مدیریت کاربران',
    name: 'نام',
    email: 'ایمیل',
    role: 'نقش',
    joined: 'تاریخ عضویت',
    storeName: 'نام فروشگاه',
    address: 'آدرس',
    rating: 'امتیاز',
    products: 'محصولات',
    productName: 'نام محصول',
    price: 'قیمت',
    stock: 'موجودی',
    status: 'وضعیت',
    orderId: 'شناسه سفارش',
    customer: 'مشتری',
    total: 'جمع',
    date: 'تاریخ',
    categoryName: 'نام دسته‌بندی',
    parentCategory: 'دسته‌بندی والد',
    mainCategory: 'دسته اصلی',
    noneTopLevel: 'بدون والد (سطح بالا)',
    sortOrder: 'ترتیب',
    confirmDelete: 'تایید حذف',
    confirmDeleteDesc: 'آیا مطمئنید که می‌خواهید این مورد را حذف کنید؟ این عمل قابل بازگشت نیست.',
    edit: 'ویرایش',
    banners: 'بنرها',
    campaigns: 'کمپین‌ها',
    campaignFlash: 'تخفیف نارنجی (فلش)',
    campaignSeasonal: 'کمپین فصلی / پک (آبی)',
    campaignCoverUrl: 'آدرس تصویر آیکون کمپین',
    createCampaign: 'ایجاد کمپین',
    campaignProducts: 'محصولات کمپین',
    campaignTitleRequired: 'عنوان کمپین الزامی است',
    noCampaigns: 'هنوز کمپیینی ثبت نشده',
    helloMessages: 'پیام خوش‌آمد',
    reviews: 'نظرات',
    addBanner: 'افزودن بنر',
    editBanner: 'ویرایش بنر',
    bannerTitle: 'عنوان بنر',
    bannerSubtitle: 'زیرعنوان',
    bannerImageUrl: 'آدرس تصویر',
    bannerLinkUrl: 'آدرس لینک',
    bannerPosition: 'موقعیت',
    bannerActive: 'فعال',
    bannerInactive: 'غیرفعال',
    homeTop: 'بالای صفحه اصلی',
    homeMiddle: 'میانه صفحه اصلی',
    storePage: 'صفحه فروشگاه',
    reviewUser: 'کاربر',
    reviewTarget: 'هدف',
    reviewRating: 'امتیاز',
    reviewComment: 'نظر',
    reviewApproved: 'تایید شده',
    reviewPending: 'در انتظار',
    approve: 'تایید',
    reject: 'رد',
    product: 'محصول',
    store: 'فروشگاه',
    noBanners: 'هیچ بنری وجود ندارد',
    noReviews: 'هیچ نظری وجود ندارد',
    canAddProducts: 'اجازه ثبت محصول',
  },
  reviews: {
    title: 'نظرات و امتیازات',
    customerReviews: 'نظرات مشتریان',
    averageRating: 'میانگین امتیاز',
    outOf5: 'از ۵',
    basedOn: 'بر اساس',
    review: 'نظر',
    writeReview: 'نوشتن نظر',
    yourRating: 'امتیاز شما',
    yourReview: 'نظر شما',
    reviewTitle: 'عنوان نظر',
    reviewPlaceholder: 'تجربه خود را با این محصول به اشتراک بگذارید...',
    titlePlaceholder: 'خلاصه‌ای از نظر خود بنویسید',
    submitReview: 'ثبت نظر',
    submitting: 'در حال ثبت...',
    loadMore: 'نمایش بیشتر',
    noReviews: 'هنوز نظری ثبت نشده',
    noReviewsDesc: 'اولین نفری باشید که نظر می‌دهد!',
    signInToReview: 'برای ثبت نظر وارد شوید',
    reviewSubmitted: 'نظر شما با موفقیت ثبت شد!',
    reviewFailed: 'ثبت نظر ناموفق بود',
    helpful: 'مفید',
    report: 'گزارش',
    verified: 'خریدار تایید شده',
    sortNewest: 'جدیدترین',
    sortHighest: 'بالاترین امتیاز',
    sortLowest: 'پایین‌ترین امتیاز',
  },
};